import React, { forwardRef } from 'react';
import { i18n } from 'src/common';
import { InputFullName, InputPhoneNumber, InputText } from 'src/components';
import { FieldConfig, Form, FormRef } from 'src/components/forms/form';
import { Validation } from 'src/components/forms/validation';

interface CustomerFormAdditionalProps {
  initialValues?: { firstName?: string; lastName?: string; phoneNumber?: string; email?: string };
  onRequestCallClick?: () => void;
}

export const CustomerFormAdditional = forwardRef<FormRef, CustomerFormAdditionalProps>(
  ({ initialValues }: CustomerFormAdditionalProps, ref) => {
    const fields: FieldConfig[] = [
      {
        name: 'fullName',
        label: i18n.t('pages.customerData.fields.fullName'),
        component: InputFullName,
        validations: [
          { type: 'required', message: i18n.t('pages.customerData.validation.fullNameRequired') },
          { type: 'validFullName', message: i18n.t('pages.customerData.validation.fullNameRequired') },
        ] as Validation[],
      },
      {
        name: 'phoneNumber',
        label: i18n.t('pages.customerData.fields.phone'),
        component: InputPhoneNumber,
        validations: [
          { type: 'required', message: i18n.t('pages.customerData.validation.phoneRequired') },
        ] as Validation[],
      },
      {
        name: 'email',
        label: i18n.t('pages.customerData.fields.email'),
        component: InputText,
        componentProps: { type: 'email' },
        validations: [
          { type: 'required', message: i18n.t('pages.customerData.validation.emailRequired') },
          { type: 'validMail', message: i18n.t('pages.customerData.validation.emailInvalid') },
          { type: 'validMailNoDiacritics', message: i18n.t('pages.customerData.validation.emailDiacritics') },
        ] as Validation[],
      },
    ];

    return (
      <Form
        ref={ref}
        fields={fields}
        onSubmit={() => {}}
        config={{ gap: 16 }}
        initialValues={initialValues}
        noValidate
      />
    );
  }
);